// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep g.blip:hover {
  background-color: red;
}

.radar-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
}

/* Buttons */
.btn-group, .btn-group-vertical {
  width: 100%;
}

.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn:last-child:not(:first-child),
.btn-group>.dropdown-toggle:not(:first-child) {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

input[type="checkbox"], input[type="radio"] {
  display:none;
  position: relative !important;
}

.btn, .btn.btn-raised {
  width: 20%;
  min-width: 40%;
  max-width: 60%;
  margin-right: 16px;
  margin-bottom: 8px;
}

.skill-button {
  min-width: 25% !important;
  max-width: 25% !important;
}

.btn.btn-raised:not(.btn-link):hover,
.btn:not(.btn-raised):not(.btn-link):hover {
  background-color: #0088cf;
  color: rgba(255,255,255, 0.7);
}

.btn.btn-raised:not(.btn-link).active,
.btn:not(.btn-raised):not(.btn-link).active {
  background-color: #0077B5;
  color: #fff;
  border-radius: 5px;
}

.btn:not(.btn-raised):not(.btn-link).not-editable:hover {
  background: none;
  cursor: default;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  .radar-container {
    height: 110vh;
    overflow: scroll;
  }

  .radar {
    height: 200vh;
    width: 50vh;
  }

  .btn.btn-raised {
    min-width: 100%;
    width: 100%;
    margin-bottom: 16px;
  }
  .skill-button {
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/TechRadarComponent/techRadar.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;;;EAGE,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF","sourcesContent":["::ng-deep g.blip:hover {\n  background-color: red;\n}\n\n.radar-container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: center;\n}\n\n/* Buttons */\n.btn-group, .btn-group-vertical {\n  width: 100%;\n}\n\n.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn:last-child:not(:first-child),\n.btn-group>.dropdown-toggle:not(:first-child) {\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\ninput[type=\"checkbox\"], input[type=\"radio\"] {\n  display:none;\n  position: relative !important;\n}\n\n.btn, .btn.btn-raised {\n  width: 20%;\n  min-width: 40%;\n  max-width: 60%;\n  margin-right: 16px;\n  margin-bottom: 8px;\n}\n\n.skill-button {\n  min-width: 25% !important;\n  max-width: 25% !important;\n}\n\n.btn.btn-raised:not(.btn-link):hover,\n.btn:not(.btn-raised):not(.btn-link):hover {\n  background-color: #0088cf;\n  color: rgba(255,255,255, 0.7);\n}\n\n.btn.btn-raised:not(.btn-link).active,\n.btn:not(.btn-raised):not(.btn-link).active {\n  background-color: #0077B5;\n  color: #fff;\n  border-radius: 5px;\n}\n\n.btn:not(.btn-raised):not(.btn-link).not-editable:hover {\n  background: none;\n  cursor: default;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  .radar-container {\n    height: 110vh;\n    overflow: scroll;\n  }\n\n  .radar {\n    height: 200vh;\n    width: 50vh;\n  }\n\n  .btn.btn-raised {\n    min-width: 100%;\n    width: 100%;\n    margin-bottom: 16px;\n  }\n  .skill-button {\n    min-width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
